<template>
  <div
    class="modal fade"
    ref="elModal"
    data-bs-backdrop="static"
    @click="closeModal"
  >
    <div class="modal-dialog modal-dialog-scrollable">
      <div class="modal-content border-0 shadow" ref="elContent">
        <slot name="offcanvas"></slot>
        <div class="modal-header justify-content-between">
          <h1 class="modal-title fs-5 flex-fill">{{ title }}</h1>
          <div class="hstack gap-2">
            <slot name="header-menu"></slot>
          </div>
        </div>
        <div class="modal-body vstack gap-3">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from "bootstrap";

export default {
  name: "EpiModal",
  props: ["openingEventName", "title"],
  data() {
    return {
      modal: null,
    };
  },
  methods: {
    closeModal(e) {
      if (e.path.length > 0 && e.path.includes(this.$refs.elContent)) return;
      this.modal.hide();
    },
    openModal() {
      this.modal.show();
    },
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.elModal);
    this.$root.$on(this.openingEventName, this.openModal);
  },
  beforeDestroy() {
    this.$root.$off(this.openingEventName, this.openModal);
  },
};
</script>
